module.exports = __webpack_public_path__ + "img/sloth-sleeping-gray-blue.0e83af38.svg";